import { useEffect, useState } from 'react';

export const useLocation = () => {
  const [permissionStatus, setPermission] = useState<
    'granted' | 'prompt' | 'denied' | null
  >(null);
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });

  function handlePermission() {
    navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      setPermission(result.state);
      if (result.state === 'prompt' || result.state === 'granted') {
        navigator.geolocation.getCurrentPosition((pos) => {
          setLocation({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          });
        });
      }
    });
  }

  async function getLocation(): Promise<string> {
    const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        setPermission(result.state);
        if (result.state === 'prompt' || result.state === 'granted') {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        }
      });
    });

    const lat = pos.coords.latitude;
    const lon = pos.coords.longitude;

    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`,
    );
    const data = await res.json();

    return `${data.address.road}, ${data.address.house_number}, ${data.address.city},  ${data.address.postcode} `;
  }

  useEffect(() => {
    handlePermission();
  }, []);

  return {
    permissionStatus,
    location,
    getLocation,
  };
};
